// Vinyl-wall-shelf hover — idle-scope kind. Face-out vinyl display on the
// wall; hovering a sleeve outlines it + makes it E-eligible. No browse
// engagement (unlike vinyl-bin) — it's a wall display, not a fan-out crate.
//
// Shares `stage.hoveredVinyl` with vinyl-bin (the two paths populate the
// same outline state because both end at `inspectVinyl`). vinyl-bin has
// higher precedence; when active, this kind is suppressed via
// `stage.activeVinylBin` so the two never write to hoveredVinyl in the
// same frame.

import { registerInteractable } from "../_interactable-registry.js";
import { addOutline, removeOutline } from "../helpers.js";

registerInteractable({
	id: "vinyl-wall-shelf",
	precedence: 45,
	// ASK-137 §84 — THIS KIND'S OWN PROMPT AND SUBJECT. `stage.js` used to enumerate every kind by
	// hand, twice (`_updateEHint`'s hover ladder and `_hoveredProduct`), which is exactly what the
	// registry's own header says a registry exists to end. The prompt a shopper reads and the product
	// it names belong where the rest of this kind's behaviour already is.
	hoverHint: '<kbd>E</kbd> Inspect',
	productOf(stage, active) {
		return active?.userData?.interactable?.product ?? stage.hoveredVinyl?.userData?.interactable?.product ?? null;
	},

	// Full idle-scope gating: box / hero / vinyl-bin / stack-table / pile /
	// book / spinner all suppress.
	suppressedBy(stage) {
		if (stage.boxState === "open" || stage.boxState === "browsing" || stage.boxState === "hero") return true;
		if (stage.activeFixtureHero) return true;
		if (stage.activeVinylBin)    return true;
		if (stage.activeStackTable)  return true;
		if (stage.hoveredPileComic)  return true;
		if (stage.hoveredBook)       return true;
		if (stage.spinnerRack?.hoveredComic) return true;
		if (!stage.vinylSleeves?.length) return true;
		return false;
	},

	// Raycast against the SHARED vinyl-sleeves pool (see vinyl-bin.js for
	// rationale — closest-overall must win, not closest-per-kind).
	getTargets(stage) {
		return stage.vinylSleeves.map((v) => v.mesh);
	},

	onHit(stage, mesh) {
		if (mesh.userData?.interactable?.fixtureKind !== "vinyl-wall-shelf") return null;
		return mesh;
	},

	commitHover(stage, prev, next) {
		if (prev === next) return;
		if (prev && stage.hoveredVinyl === prev) removeOutline(prev);
		stage.hoveredVinyl = next;
		if (next) addOutline(next);
	},

	interactE(stage) {
		if (!stage.hoveredVinyl) return false;
		if (stage.boxState === "closed") stage.forceCloseActiveBox();
		stage.inspectVinyl(stage.hoveredVinyl.userData.vinylIdx);
		return true;
	},
});
